import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const WidgetTitle = ({ isCampaignLandingPage }) => {
  const [t] = useTranslation();

  return (
    <h2 className="h2 display-3 mb-3">
      {isCampaignLandingPage ? t('PM_CAMPAIGN_WIDGET') : t('PM_KIT_UI1')}
    </h2>
  );
};

WidgetTitle.propTypes = {
  isCampaignLandingPage: PropTypes.bool
};

export default WidgetTitle;
